import dayjs from 'dayjs';
import { ScheduleAvailabilityTypes as Types } from '@frontend/api-schedule-availability';

export const MAX_WIDTH = 720;

export const DAYS_OF_WEEK = [
  Types.Weekday.sunday,
  Types.Weekday.monday,
  Types.Weekday.tuesday,
  Types.Weekday.wednesday,
  Types.Weekday.thursday,
  Types.Weekday.friday,
  Types.Weekday.saturday,
] as const;

export const WeekDayName: Record<Types.Weekday, string> = {
  [Types.Weekday.sunday]: dayjs().set('d', 0).format('dddd'),
  [Types.Weekday.monday]: dayjs().set('d', 1).format('dddd'),
  [Types.Weekday.tuesday]: dayjs().set('d', 2).format('dddd'),
  [Types.Weekday.wednesday]: dayjs().set('d', 3).format('dddd'),
  [Types.Weekday.thursday]: dayjs().set('d', 4).format('dddd'),
  [Types.Weekday.friday]: dayjs().set('d', 5).format('dddd'),
  [Types.Weekday.saturday]: dayjs().set('d', 6).format('dddd'),
};

export const ShortWeekDayName: Record<Types.Weekday, string> = {
  [Types.Weekday.sunday]: dayjs().set('d', 0).format('ddd'),
  [Types.Weekday.monday]: dayjs().set('d', 1).format('ddd'),
  [Types.Weekday.tuesday]: dayjs().set('d', 2).format('ddd'),
  [Types.Weekday.wednesday]: dayjs().set('d', 3).format('ddd'),
  [Types.Weekday.thursday]: dayjs().set('d', 4).format('ddd'),
  [Types.Weekday.friday]: dayjs().set('d', 5).format('ddd'),
  [Types.Weekday.saturday]: dayjs().set('d', 6).format('ddd'),
};
